export default {"src":"/_next/static/media/40-icon.b8fa0a64.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};